// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/svg/checked.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e9ecef; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #a0aec0; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
html {
		font-family: 'DM Sans', sans-serif !important;
		font-feature-settings: 'kern' !important;
		-webkit-font-smoothing: antialiased;
		letter-spacing: -0.5px;
	}
.container{
  width: 100%;
}
@media (min-width: 576px){
  .container{
    max-width: 576px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 992px){
  .container{
    max-width: 992px;
  }
}
@media (min-width: 1200px){
  .container{
    max-width: 1200px;
  }
}
@media (min-width: 1320px){
  .container{
    max-width: 1320px;
  }
}
@media (min-width: 1600px){
  .container{
    max-width: 1600px;
  }
}
@media (min-width: 1850px){
  .container{
    max-width: 1850px;
  }
}
.visible{
  visibility: visible;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.-bottom-12{
  bottom: -3rem;
}
.-left-6{
  left: -1.5rem;
}
.-left-\\[180px\\]{
  left: -180px;
}
.-left-\\[230px\\]{
  left: -230px;
}
.-start-\\[180px\\]{
  inset-inline-start: -180px;
}
.-start-\\[230px\\]{
  inset-inline-start: -230px;
}
.-start-\\[250px\\]{
  inset-inline-start: -250px;
}
.-top-12{
  top: -3rem;
}
.-top-4{
  top: -1rem;
}
.-top-6{
  top: -1.5rem;
}
.bottom-\\[30px\\]{
  bottom: 30px;
}
.end-0{
  inset-inline-end: 0px;
}
.end-4{
  inset-inline-end: 1rem;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-3{
  left: 0.75rem;
}
.right-0{
  right: 0px;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-\\[-7px\\]{
  right: -7px;
}
.right-\\[35px\\]{
  right: 35px;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-11{
  top: 2.75rem;
}
.top-2{
  top: 0.5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-6{
  top: 1.5rem;
}
.top-8{
  top: 2rem;
}
.top-\\[-7px\\]{
  top: -7px;
}
.top-px{
  top: 1px;
}
.\\!z-50{
  z-index: 50 !important;
}
.\\!z-\\[99\\]{
  z-index: 99 !important;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[5\\]{
  z-index: 5;
}
.z-\\[999\\]{
  z-index: 999;
}
.order-1{
  order: 1;
}
.order-2{
  order: 2;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.col-span-6{
  grid-column: span 6 / span 6;
}
.float-right{
  float: right;
}
.m-1{
  margin: 0.25rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-\\[12px\\]{
  margin-left: 12px;
  margin-right: 12px;
}
.mx-\\[56px\\]{
  margin-left: 56px;
  margin-right: 56px;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-\\[12px\\]{
  margin-top: 12px;
  margin-bottom: 12px;
}
.my-\\[3px\\]{
  margin-top: 3px;
  margin-bottom: 3px;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.-mr-3{
  margin-right: -0.75rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-16{
  margin-bottom: 4rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-9{
  margin-bottom: 2.25rem;
}
.mb-auto{
  margin-bottom: auto;
}
.mb-px{
  margin-bottom: 1px;
}
.me-1{
  margin-inline-end: 0.25rem;
}
.me-2{
  margin-inline-end: 0.5rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-\\[6px\\]{
  margin-left: 6px;
}
.ml-auto{
  margin-left: auto;
}
.ml-px{
  margin-left: 1px;
}
.mr-0{
  margin-right: 0px;
}
.mr-12{
  margin-right: 3rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-5{
  margin-right: 1.25rem;
}
.ms-1{
  margin-inline-start: 0.25rem;
}
.ms-2{
  margin-inline-start: 0.5rem;
}
.ms-3{
  margin-inline-start: 0.75rem;
}
.ms-4{
  margin-inline-start: 1rem;
}
.ms-\\[6px\\]{
  margin-inline-start: 6px;
}
.mt-0{
  margin-top: 0px;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-14{
  margin-top: 3.5rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[10vh\\]{
  margin-top: 10vh;
}
.mt-\\[20px\\]{
  margin-top: 20px;
}
.mt-\\[3px\\]{
  margin-top: 3px;
}
.mt-\\[50px\\]{
  margin-top: 50px;
}
.mt-\\[58px\\]{
  margin-top: 58px;
}
.mt-px{
  margin-top: 1px;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[150px\\]{
  height: 150px;
}
.h-\\[15px\\]{
  height: 15px;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[220px\\]{
  height: 220px;
}
.h-\\[250px\\]{
  height: 250px;
}
.h-\\[3\\.4rem\\]{
  height: 3.4rem;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[32px\\]{
  height: 32px;
}
.h-\\[450px\\]{
  height: 450px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[61px\\]{
  height: 61px;
}
.h-\\[650px\\]{
  height: 650px;
}
.h-\\[70px\\]{
  height: 70px;
}
.h-\\[730px\\]{
  height: 730px;
}
.h-\\[83px\\]{
  height: 83px;
}
.h-\\[87px\\]{
  height: 87px;
}
.h-\\[90px\\]{
  height: 90px;
}
.h-fit{
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.max-h-\\[600px\\]{
  max-height: 600px;
}
.min-h-\\[120px\\]{
  min-height: 120px;
}
.min-h-\\[160px\\]{
  min-height: 160px;
}
.min-h-\\[20px\\]{
  min-height: 20px;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[320px\\]{
  min-height: 320px;
}
.min-h-\\[400px\\]{
  min-height: 400px;
}
.min-h-\\[650px\\]{
  min-height: 650px;
}
.min-h-\\[84vh\\]{
  min-height: 84vh;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.\\!w-\\[300px\\]{
  width: 300px !important;
}
.w-0{
  width: 0px;
}
.w-1{
  width: 0.25rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-1\\/5{
  width: 20%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-2{
  width: 0.5rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-3{
  width: 0.75rem;
}
.w-4{
  width: 1rem;
}
.w-5{
  width: 1.25rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-7{
  width: 1.75rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[108px\\]{
  width: 108px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[15px\\]{
  width: 15px;
}
.w-\\[170px\\]{
  width: 170px;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[20px\\]{
  width: 20px;
}
.w-\\[224px\\]{
  width: 224px;
}
.w-\\[256px\\]{
  width: 256px;
}
.w-\\[32px\\]{
  width: 32px;
}
.w-\\[350px\\]{
  width: 350px;
}
.w-\\[355px\\]{
  width: 355px;
}
.w-\\[360px\\]{
  width: 360px;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[70px\\]{
  width: 70px;
}
.w-\\[83px\\]{
  width: 83px;
}
.w-\\[85px\\]{
  width: 85px;
}
.w-\\[87px\\]{
  width: 87px;
}
.w-\\[calc\\(100\\%-110px\\)\\]{
  width: calc(100% - 110px);
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.min-w-\\[300px\\]{
  min-width: 300px;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-\\[300px\\]{
  max-width: 300px;
}
.max-w-\\[400px\\]{
  max-width: 400px;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-fit{
  max-width: fit-content;
}
.max-w-full{
  max-width: 100%;
}
.max-w-none{
  max-width: none;
}
.max-w-screen-sm{
  max-width: 576px;
}
.flex-1{
  flex: 1 1;
}
.flex-none{
  flex: none;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.flex-grow{
  flex-grow: 1;
}
.origin-\\[65\\%_0\\%\\]{
  transform-origin: 65% 0%;
}
.origin-\\[75\\%_0\\%\\]{
  transform-origin: 75% 0%;
}
.origin-top-right{
  transform-origin: top right;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-96{
  --tw-translate-x: -24rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-3\\/4{
  --tw-translate-x: 75%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-full{
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0{
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-pointer{
  cursor: pointer;
}
.resize{
  resize: both;
}
.list-disc{
  list-style-type: disc;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.\\!flex-row{
  flex-direction: row !important;
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.\\!flex-col{
  flex-direction: column !important;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-center{
  align-items: center;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.\\!justify-between{
  justify-content: space-between !important;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-8{
  gap: 2rem;
}
.space-x-12 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(3rem * var(--tw-space-x-reverse));
  margin-left: calc(3rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.overflow-x-scroll{
  overflow-x: scroll;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.\\!rounded-full{
  border-radius: 9999px !important;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[14px\\]{
  border-radius: 14px;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.\\!border-0{
  border-width: 0px !important;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-\\[2px\\]{
  border-width: 2px;
}
.border-\\[4px\\]{
  border-width: 4px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-\\[1px\\]{
  border-bottom-width: 1px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.\\!border-none{
  border-style: none !important;
}
.\\!border-gray-300{
  --tw-border-opacity: 1 !important;
  border-color: rgb(203 213 224 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-gray-400{
  --tw-border-opacity: 1 !important;
  border-color: rgb(160 174 192 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-green-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-red-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(245 57 57 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#6a53ff\\]{
  --tw-border-opacity: 1;
  border-color: rgb(106 83 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#BE9811\\]{
  --tw-border-opacity: 1;
  border-color: rgb(190 152 17 / var(--tw-border-opacity, 1));
}
.border-\\[\\#C275FF\\]{
  --tw-border-opacity: 1;
  border-color: rgb(194 117 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#DADADA\\]{
  --tw-border-opacity: 1;
  border-color: rgb(218 218 218 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EBEBEB\\]{
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FFBCAB\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 188 171 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 236 239 / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 224 / var(--tw-border-opacity, 1));
}
.border-gray-500{
  --tw-border-opacity: 1;
  border-color: rgb(173 181 189 / var(--tw-border-opacity, 1));
}
.border-gray-600{
  --tw-border-opacity: 1;
  border-color: rgb(163 174 208 / var(--tw-border-opacity, 1));
}
.border-gray-700{
  --tw-border-opacity: 1;
  border-color: rgb(112 126 174 / var(--tw-border-opacity, 1));
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-purple-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity, 1));
}
.border-purple-500{
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.border-purple-800{
  --tw-border-opacity: 1;
  border-color: rgb(107 33 168 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(245 57 57 / var(--tw-border-opacity, 1));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/0{
  border-color: rgb(255 255 255 / 0);
}
.border-b-\\[\\#EBEBEB\\]{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(235 235 235 / var(--tw-border-opacity, 1));
}
.border-b-gray-400{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(160 174 192 / var(--tw-border-opacity, 1));
}
.border-r-\\[\\#EBEBEB\\]{
  --tw-border-opacity: 1;
  border-right-color: rgb(235 235 235 / var(--tw-border-opacity, 1));
}
.border-r-gray-300{
  --tw-border-opacity: 1;
  border-right-color: rgb(203 213 224 / var(--tw-border-opacity, 1));
}
.\\!bg-\\[\\#F0EEF7\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 238 247 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#ffe9c2\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 233 194 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-gray-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(237 242 247 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-white{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#0084D6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 132 214 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#23C581\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(35 197 129 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6AD2FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(106 210 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6D6B85\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(109 107 133 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#93DAFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(147 218 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#B0DEC7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(176 222 199 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#B1DFC9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(177 223 201 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#C184F0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(193 132 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#C386F1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(195 134 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E0E5F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(224 229 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E7FAF0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(231 250 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F0EEF7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 238 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5E9FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(245 233 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F5F5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F6F2F7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 242 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FDC9BD\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(253 201 189 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FEEDE9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(254 237 233 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFBCAB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 188 171 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFCABE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 202 190 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#be98115c\\]{
  background-color: #be98115c;
}
.bg-\\[\\#e0e5f2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(224 229 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-brand-500{
  --tw-bg-opacity: 1;
  background-color: rgb(66 42 251 / var(--tw-bg-opacity, 1));
}
.bg-brand-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 4 122 / var(--tw-bg-opacity, 1));
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(23 193 232 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(237 242 247 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(233 236 239 / var(--tw-bg-opacity, 1));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 224 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(173 181 189 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  background-color: #05cd991a;
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-lightPrimary{
  --tw-bg-opacity: 1;
  background-color: rgb(244 247 254 / var(--tw-bg-opacity, 1));
}
.bg-lime-500{
  --tw-bg-opacity: 1;
  background-color: rgb(130 214 22 / var(--tw-bg-opacity, 1));
}
.bg-navy-500{
  --tw-bg-opacity: 1;
  background-color: rgb(27 59 187 / var(--tw-bg-opacity, 1));
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-pink-400{
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity, 1));
}
.bg-pink-500{
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 128 / var(--tw-bg-opacity, 1));
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  background-color: #ee5d501a;
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 57 57 / var(--tw-bg-opacity, 1));
}
.bg-teal-500{
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/0{
  background-color: rgb(255 255 255 / 0);
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-yellow-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-opacity-20{
  --tw-bg-opacity: 0.2;
}
.\\!bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops)) !important;
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-none{
  background-image: none;
}
.\\!from-\\[\\#FFFFFF\\]{
  --tw-gradient-from: #FFFFFF var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.from-\\[\\#7F03E2\\]{
  --tw-gradient-from: #7F03E2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(127 3 226 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#868CFF\\]{
  --tw-gradient-from: #868CFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(134 140 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F9FAFC\\]{
  --tw-gradient-from: #F9FAFC var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FFFFFF\\]{
  --tw-gradient-from: #FFFFFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#ffffff\\]{
  --tw-gradient-from: #ffffff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-brandLinear{
  --tw-gradient-from: #868CFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(134 140 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50{
  --tw-gradient-from: #f8f9fa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 249 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-500{
  --tw-gradient-from: #ff0080 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 0 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-100\\/50{
  --tw-gradient-from: rgb(243 232 255 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 232 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50{
  --tw-gradient-from: #faf5ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500{
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600{
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #ffffff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/50{
  --tw-gradient-from: rgb(255 255 255 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/80{
  --tw-gradient-from: rgb(255 255 255 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#432CF3\\]{
  --tw-gradient-to: rgb(67 44 243 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #432CF3 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-pink-500{
  --tw-gradient-to: rgb(255 0 128 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ff0080 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-50{
  --tw-gradient-to: rgb(250 245 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #faf5ff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ffffff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.\\!to-\\[\\#FDF7FF\\]{
  --tw-gradient-to: #FDF7FF var(--tw-gradient-to-position) !important;
}
.to-\\[\\#A13BF2\\]{
  --tw-gradient-to: #A13BF2 var(--tw-gradient-to-position);
}
.to-\\[\\#FAF5FC\\]{
  --tw-gradient-to: #FAF5FC var(--tw-gradient-to-position);
}
.to-\\[\\#FCF5F5\\]{
  --tw-gradient-to: #FCF5F5 var(--tw-gradient-to-position);
}
.to-\\[\\#FDF7FF\\]{
  --tw-gradient-to: #FDF7FF var(--tw-gradient-to-position);
}
.to-blueSecondary{
  --tw-gradient-to: #4318FF var(--tw-gradient-to-position);
}
.to-brand-500{
  --tw-gradient-to: #422AFB var(--tw-gradient-to-position);
}
.to-pink-500{
  --tw-gradient-to: #ff0080 var(--tw-gradient-to-position);
}
.to-purple-50{
  --tw-gradient-to: #faf5ff var(--tw-gradient-to-position);
}
.to-purple-50\\/20{
  --tw-gradient-to: rgb(250 245 255 / 0.2) var(--tw-gradient-to-position);
}
.to-purple-50\\/50{
  --tw-gradient-to: rgb(250 245 255 / 0.5) var(--tw-gradient-to-position);
}
.to-purple-500{
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}
.to-purple-600{
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: #ffffff var(--tw-gradient-to-position);
}
.to-white\\/10{
  --tw-gradient-to: rgb(255 255 255 / 0.1) var(--tw-gradient-to-position);
}
.bg-cover{
  background-size: cover;
}
.bg-clip-border{
  background-clip: border-box;
}
.bg-clip-text{
  background-clip: text;
}
.bg-center{
  background-position: center;
}
.bg-no-repeat{
  background-repeat: no-repeat;
}
.fill-blue-600{
  fill: #2152ff;
}
.object-cover{
  object-fit: cover;
}
.\\!p-0{
  padding: 0px !important;
}
.\\!p-2{
  padding: 0.5rem !important;
}
.\\!p-4{
  padding: 1rem !important;
}
.\\!p-\\[20px\\]{
  padding: 20px !important;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[16px\\]{
  padding: 16px;
}
.p-\\[20px\\]{
  padding: 20px;
}
.p-\\[26px\\]{
  padding: 26px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-11{
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}
.px-12{
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[20px\\]{
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[40px\\]{
  padding-left: 40px;
  padding-right: 40px;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-\\[11px\\]{
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[12px\\]{
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[30px\\]{
  padding-top: 30px;
  padding-bottom: 30px;
}
.\\!pb-14{
  padding-bottom: 3.5rem !important;
}
.\\!pr-3{
  padding-right: 0.75rem !important;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-7{
  padding-bottom: 1.75rem;
}
.pb-9{
  padding-bottom: 2.25rem;
}
.pb-\\[32px\\]{
  padding-bottom: 32px;
}
.pe-2{
  padding-inline-end: 0.5rem;
}
.pe-4{
  padding-inline-end: 1rem;
}
.pl-0{
  padding-left: 0px;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pr-0{
  padding-right: 0px;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.ps-3{
  padding-inline-start: 0.75rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-12{
  padding-top: 3rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-20{
  padding-top: 5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-32{
  padding-top: 8rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-start{
  text-align: start;
}
.font-dm{
  font-family: DM Sans, sans-serif;
}
.font-poppins{
  font-family: Poppins, sans-serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[26px\\]{
  font-size: 26px;
}
.text-\\[33px\\]{
  font-size: 33px;
}
.text-\\[34px\\]{
  font-size: 34px;
}
.text-\\[80px\\]{
  font-size: 80px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.leading-4{
  line-height: 1rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-9{
  line-height: 2.25rem;
}
.leading-relaxed{
  line-height: 1.625;
}
.\\!text-\\[\\#f43f5e\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-gray-600{
  --tw-text-opacity: 1 !important;
  color: rgb(163 174 208 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#000\\]{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0084D6\\]{
  --tw-text-opacity: 1;
  color: rgb(0 132 214 / var(--tw-text-opacity, 1));
}
.text-\\[\\#23C581\\]{
  --tw-text-opacity: 1;
  color: rgb(35 197 129 / var(--tw-text-opacity, 1));
}
.text-\\[\\#333333\\]{
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3B3A44\\]{
  --tw-text-opacity: 1;
  color: rgb(59 58 68 / var(--tw-text-opacity, 1));
}
.text-\\[\\#45007C\\]{
  --tw-text-opacity: 1;
  color: rgb(69 0 124 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6D6B85\\]{
  --tw-text-opacity: 1;
  color: rgb(109 107 133 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8912E7\\]{
  --tw-text-opacity: 1;
  color: rgb(137 18 231 / var(--tw-text-opacity, 1));
}
.text-\\[\\#A09EB5\\]{
  --tw-text-opacity: 1;
  color: rgb(160 158 181 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C275FF\\]{
  --tw-text-opacity: 1;
  color: rgb(194 117 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D1D1D1\\]{
  --tw-text-opacity: 1;
  color: rgb(209 209 209 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E35A5A\\]{
  --tw-text-opacity: 1;
  color: rgb(227 90 90 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFFFFF\\]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-blue-400{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(33 82 255 / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(52 78 134 / var(--tw-text-opacity, 1));
}
.text-brand-500{
  --tw-text-opacity: 1;
  color: rgb(66 42 251 / var(--tw-text-opacity, 1));
}
.text-gray-200{
  --tw-text-opacity: 1;
  color: rgb(233 236 239 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(160 174 192 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(173 181 189 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(163 174 208 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(112 126 174 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(37 47 64 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(27 37 89 / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(23 173 55 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-navy-700{
  --tw-text-opacity: 1;
  color: rgb(27 37 75 / var(--tw-text-opacity, 1));
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.text-purple-200{
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}
.text-purple-300{
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(121 40 202 / var(--tw-text-opacity, 1));
}
.text-purple-800{
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-purple-900{
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(245 57 57 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/0{
  color: rgb(255 255 255 / 0);
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.opacity-0{
  opacity: 0;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-90{
  opacity: 0.9;
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-3xl{
  --tw-shadow: 14px 17px 40px 4px;
  --tw-shadow-colored: 14px 17px 40px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-shadow-500{
  --tw-shadow-color: rgba(112, 144, 176, 0.08);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-white\\/5{
  --tw-shadow-color: rgb(255 255 255 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-\\[2px\\]{
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\\!transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.\\!duration-200{
  transition-duration: 200ms !important;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-\\[0\\.2s\\]{
  transition-duration: 0.2s;
}
.duration-\\[0\\.5s\\]{
  transition-duration: 0.5s;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.pe-2{
  padding-inline-end: 0.5rem;
}
.ps-3{
  padding-inline-start: 0.75rem;
}
.pe-4{
  padding-inline-end: 1rem;
}
.ms-1{
  margin-inline-start: 0.25rem;
}
.me-1{
  margin-inline-end: 0.25rem;
}
.ms-2{
  margin-inline-start: 0.5rem;
}
.me-2{
  margin-inline-end: 0.5rem;
}
.ms-3{
  margin-inline-start: 0.75rem;
}
.ms-4{
  margin-inline-start: 1rem;
}
[dir="rtl"] .end-0{
  left: 0px;
}
[dir="ltr"] .end-0{
  right: 0px;
}
[dir="rtl"] .end-4{
  left: 1rem;
}
[dir="ltr"] .end-4{
  right: 1rem;
}
[dir="rtl"] .text-start{
  text-align: right;
}
[dir="ltr"] .text-start{
  text-align: left;
}

input.defaultCheckbox::before {
	content: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); 
	color: white;
	opacity: 0; 
	height: 16px; 
	width: 16px;
	position: absolute; 
	left: 50%;
	transform: translate(-50%, 0px);
} 

input:checked.defaultCheckbox::before { 
	opacity: 1;
}

a {
	text-decoration: none !important;
}

a:hover {
	text-decoration: none !important;
}

.embla {
	/* max-width: 70rem; */
	/* margin: auto; */
	--slide-height: 150px;
	--slide-spacing: 0rem;
	--slide-size: 100%;
	--slide-spacing-sm: 0rem;
	--slide-size-sm: calc(100% / 2);;
	--slide-spacing-lg: 0rem;
	--slide-size-md: calc(100% / 3);
	--slide-size-lg: calc(100% / 5);
}

.embla__viewport {
	overflow-x: hidden;
	overflow-y: hidden;
}

.embla__container {
	/* backface-visibility: hidden; */
	display: flex;
	touch-action: pan-y pinch-zoom;
	margin-left: calc(var(--slide-spacing) * -1);
}

@media (min-width: 750px) {
	.embla__container {
		margin-left: calc(var(--slide-spacing-sm) * -1);
	}
}

@media (min-width: 1200px) {
	.embla__container {
		margin-left: calc(var(--slide-spacing-md) * -1);
	}
}

.embla__slide {
	min-width: 0;
	flex: 0 0 var(--slide-size);
	padding-left: var(--slide-spacing);
}

@media (min-width: 750px) {
	.embla__slide {
		flex: 0 0 var(--slide-size-sm);
		padding-left: var(--slide-spacing-sm);
	}
}

@media (min-width: 1200px) {
	.embla__slide {
		flex: 0 0 var(--slide-size-md);
		padding-left: var(--slide-spacing-lg);
	}
}

@media (min-width: 1700px) {
	.embla__slide {
		flex: 0 0 var(--slide-size-lg);
		padding-left: var(--slide-spacing-lg);
	}
}

.embla__slide__number {
	box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
	/* border-radius: 1.8rem; */
	display: flex;
	align-items: center;
	justify-content: center;
	height: var(--slide-height);
	-webkit-user-select: none;
	        user-select: none;
}

.embla__controls {
	display: flex;
	grid-template-columns: auto 1fr;
	justify-content: space-between;
	/* width: 100%; */
	gap: 1.2rem;
	/* margin-top: 1.8rem; */
}

.embla__buttons {
	display: flex;
	grid-template-columns: repeat(2, 1fr);
	gap: 0.7rem;
	align-items: center;
	/* width: calc(100% + 52px); */
	/* justify-content: space-between; */
}

.embla__button {
	-webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);
	appearance: none;
	background-color: transparent;
	touch-action: manipulation;
	display: inline-flex;
	text-decoration: none;
	cursor: pointer;
	border: 0;
	padding: 0;
	margin: 0;
	box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
	width: 1.6rem;
	height: 1.6rem;
	border-radius: 50%;
	color: var(--text-body);
	display: flex;
	align-items: center;
	justify-content: center;
}

.embla__button:disabled {
	color: var(--detail-high-contrast);
}

.embla__button__svg {
	width: 35%;
	height: 35%;
}

.embla__dots {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-end;
	align-items: center;
	margin-right: calc((2.6rem - 1.4rem) / 2 * -1);
}

.embla__dot {
	-webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);
	appearance: none;
	background-color: transparent;
	touch-action: manipulation;
	display: inline-flex;
	text-decoration: none;
	cursor: pointer;
	border: 0;
	padding: 0;
	margin: 0;
	width: 2.6rem;
	height: 2.6rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
}

.embla__dot:after {
	box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
	width: 1.4rem;
	height: 1.4rem;
	border-radius: 50%;
	display: flex;
	align-items: center;
	content: '';
}

.embla__dot--selected:after {
	box-shadow: inset 0 0 0 0.2rem var(--text-body);
}

.rs-avatar {
  width: 80px !important;
  height: 80px !important;
  border-radius: 50%;
}	
.rs-avatar>.rs-avatar-image {
  width: 80px !important;
  height: auto !important;
}
.swiper {
	width: 100%;
	padding: 50px 0;
  }
  
  .features-swiper .swiper-slide,
  .testimonials-swiper .swiper-slide {
	height: auto;
  }
  
  .showcase-swiper {
	padding-top: 50px;
	padding-bottom: 50px;
  }
  
  .showcase-swiper .swiper-slide {
	background-position: center;
	background-size: cover;
	width: 300px;
	height: 300px;
  }
  
  .showcase-swiper .swiper-slide img {
	display: block;
	width: 100%;
  }
  
  .swiper-button-next,
  .swiper-button-prev {
	color: #7F03E2 !important;
  }
  
  .swiper-pagination-bullet-active {
	background: #7F03E2 !important;
  }
  
  /* Add smooth transitions */
  .swiper-slide {
	transition: all 0.3s ease;
  }
  .swiper-initialized .swiper-wrapper {
	transition-timing-function: linear;
	padding-top: 40px !important;
	padding-bottom: 40px !important;
  }
  
  .swiper-slide-active {
	transform: scale(1.05);
  }
  .swiper-button-next, .swiper-button-prev {
	display: none !important;
  }
  .features-swiper {
	padding: 50px 0;
  }
  
  .features-swiper .swiper-slide {
	width: 400px;
  }
  
  .features-swiper .swiper-slide-shadow-left,
  .features-swiper .swiper-slide-shadow-right {
	border-radius: 8px;
  }
  .features-swiper .swiper-pagination-bullet {
	width: 10px;
	height: 10px;
	background: #e9d5ff;
	opacity: 1;
  }
  
  .features-swiper .swiper-pagination-bullet-active {
	background: linear-gradient(to right, #9333ea, #db2777);
	transform: scale(1.2);
  }
  
  .placeholder\\:\\!text-gray-400::placeholder{
  --tw-text-opacity: 1 !important;
  color: rgb(160 174 192 / var(--tw-text-opacity, 1)) !important;
}
  
  .placeholder\\:text-green-500::placeholder{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
  
  .placeholder\\:text-red-500::placeholder{
  --tw-text-opacity: 1;
  color: rgb(245 57 57 / var(--tw-text-opacity, 1));
}
  
  .before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}
  
  .before\\:left-\\[50\\%\\]::before{
  content: var(--tw-content);
  left: 50%;
}
  
  .before\\:top-\\[3px\\]::before{
  content: var(--tw-content);
  top: 3px;
}
  
  .before\\:top-\\[50\\%\\]::before{
  content: var(--tw-content);
  top: 50%;
}
  
  .before\\:h-3::before{
  content: var(--tw-content);
  height: 0.75rem;
}
  
  .before\\:h-4::before{
  content: var(--tw-content);
  height: 1rem;
}
  
  .before\\:w-3::before{
  content: var(--tw-content);
  width: 0.75rem;
}
  
  .before\\:w-4::before{
  content: var(--tw-content);
  width: 1rem;
}
  
  .before\\:translate-x-\\[-50\\%\\]::before{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  
  .before\\:translate-x-\\[2px\\]::before{
  content: var(--tw-content);
  --tw-translate-x: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  
  .before\\:translate-y-\\[-50\\%\\]::before{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  
  .before\\:rounded-\\[20px\\]::before{
  content: var(--tw-content);
  border-radius: 20px;
}
  
  .before\\:rounded-full::before{
  content: var(--tw-content);
  border-radius: 9999px;
}
  
  .before\\:bg-white::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
  
  .before\\:shadow-\\[0_2px_5px_rgba\\(0\\2c _0\\2c _0\\2c _\\.2\\)\\]::before{
  content: var(--tw-content);
  --tw-shadow: 0 2px 5px rgba(0, 0, 0, .2);
  --tw-shadow-colored: 0 2px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  
  .before\\:transition::before{
  content: var(--tw-content);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
  
  .before\\:transition-all::before{
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
  
  .before\\:duration-\\[0\\.2s\\]::before{
  content: var(--tw-content);
  transition-duration: 0.2s;
}
  
  .before\\:content-\\[\\"\\"\\]::before{
  --tw-content: "";
  content: var(--tw-content);
}
  
  .last\\:border-0:last-child{
  border-width: 0px;
}
  
  .last\\:pb-0:last-child{
  padding-bottom: 0px;
}
  
  .checked\\:border-none:checked{
  border-style: none;
}
  
  .checked\\:\\!border-amber-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-blue-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-brand-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(66 42 251 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-cyan-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(23 193 232 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-gray-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(173 181 189 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-green-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-indigo-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-lime-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(130 214 22 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-navy-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(27 59 187 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-orange-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-pink-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 0 128 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-purple-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-red-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(245 57 57 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-teal-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:\\!border-yellow-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(234 179 8 / var(--tw-border-opacity, 1)) !important;
}
  
  .checked\\:bg-amber-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-blue-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-brand-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(66 42 251 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-cyan-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(23 193 232 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-gray-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(173 181 189 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-green-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-indigo-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-lime-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(130 214 22 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-navy-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(27 59 187 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-orange-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-pink-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 128 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-purple-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-red-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(245 57 57 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-teal-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:bg-yellow-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
  
  .checked\\:text-white:checked{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
  
  .checked\\:before\\:translate-x-\\[22px\\]:checked::before{
  content: var(--tw-content);
  --tw-translate-x: 22px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  
  .checked\\:before\\:\\!bg-amber-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-blue-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-brand-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(66 42 251 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-cyan-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(23 193 232 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-gray-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(173 181 189 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-green-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-indigo-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-lime-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(130 214 22 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-navy-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(27 59 187 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-orange-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-pink-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 0 128 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-purple-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-red-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 57 57 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-teal-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1)) !important;
}
  
  .checked\\:before\\:\\!bg-yellow-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1)) !important;
}
  
  .hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  
  .hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  
  .hover\\:scale-125:hover{
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  
  .hover\\:scale-\\[1\\.02\\]:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  
  .hover\\:cursor-pointer:hover{
  cursor: pointer;
}
  
  .hover\\:border-\\[\\#FFBCAB\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(255 188 171 / var(--tw-border-opacity, 1));
}
  
  .hover\\:bg-\\[\\#6D6B85\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(109 107 133 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:bg-\\[\\#d0a0f7\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(208 160 247 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:bg-brand-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(51 17 219 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:bg-brand-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(25 7 147 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(237 242 247 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(233 236 239 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:bg-purple-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:bg-purple-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:bg-white\\/80:hover{
  background-color: rgb(255 255 255 / 0.8);
}
  
  .hover\\:bg-opacity-30:hover{
  --tw-bg-opacity: 0.3;
}
  
  .hover\\:bg-gradient-to-b:hover{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
  
  .hover\\:bg-gradient-to-t:hover{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
  
  .hover\\:bg-none:hover{
  background-image: none;
}
  
  .hover\\:from-gray-100:hover{
  --tw-gradient-from: #edf2f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(237 242 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
  
  .hover\\:from-white\\/40:hover{
  --tw-gradient-from: rgb(255 255 255 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
  
  .hover\\:to-purple-100:hover{
  --tw-gradient-to: #f3e8ff var(--tw-gradient-to-position);
}
  
  .hover\\:to-white\\/5:hover{
  --tw-gradient-to: rgb(255 255 255 / 0.05) var(--tw-gradient-to-position);
}
  
  .hover\\:font-bold:hover{
  font-weight: 700;
}
  
  .hover\\:font-medium:hover{
  font-weight: 500;
}
  
  .hover\\:\\!text-\\[\\#fff\\]:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
  
  .hover\\:text-\\[\\#333\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-\\[\\#3B3A44\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(59 58 68 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-\\[\\#45007C\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(69 0 124 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-brand-500:hover{
  --tw-text-opacity: 1;
  color: rgb(66 42 251 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-brand-600:hover{
  --tw-text-opacity: 1;
  color: rgb(51 17 219 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-gray-600:hover{
  --tw-text-opacity: 1;
  color: rgb(163 174 208 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-gray-800:hover{
  --tw-text-opacity: 1;
  color: rgb(37 47 64 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-navy-700:hover{
  --tw-text-opacity: 1;
  color: rgb(27 37 75 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-purple-500:hover{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-purple-600:hover{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-purple-700:hover{
  --tw-text-opacity: 1;
  color: rgb(121 40 202 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(245 57 57 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
  
  .hover\\:underline:hover{
  text-decoration-line: underline;
}
  
  .hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  
  .hover\\:ease-in:hover{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
  
  .focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
  
  .focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
  
  .focus\\:ring-purple-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}
  
  .active\\:bg-brand-700:active{
  --tw-bg-opacity: 1;
  background-color: rgb(33 17 165 / var(--tw-bg-opacity, 1));
}
  
  .active\\:bg-gray-200:active{
  --tw-bg-opacity: 1;
  background-color: rgb(233 236 239 / var(--tw-bg-opacity, 1));
}
  
  .active\\:bg-none:active{
  background-image: none;
}
  
  .active\\:\\!text-\\[\\#fff\\]:active{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
  
  .group:hover .group-hover\\:w-full{
  width: 100%;
}
  
  .group:hover .group-hover\\:translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  
  .group:hover .group-hover\\:text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
  
  .group:hover .group-hover\\:opacity-10{
  opacity: 0.1;
}
  
  .group:hover .group-hover\\:shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  
  .dark\\:\\!border-gray-800:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(37 47 64 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:\\!border-green-400:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:\\!border-navy-700:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(27 37 75 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:\\!border-navy-800:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(17 28 68 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:\\!border-red-400:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:\\!border-white\\/10:is(.dark *){
  border-color: rgb(255 255 255 / 0.1) !important;
}
  
  .dark\\:border-white\\/10:is(.dark *){
  border-color: rgb(255 255 255 / 0.1);
}
  
  .dark\\:\\!bg-navy-700:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(27 37 75 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:\\!bg-navy-800:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(17 28 68 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:\\!bg-navy-900:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(11 20 55 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:\\!bg-white:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:\\!bg-white\\/5:is(.dark *){
  background-color: rgb(255 255 255 / 0.05) !important;
}
  
  .dark\\:bg-\\[\\#0b14374d\\]:is(.dark *){
  background-color: #0b14374d;
}
  
  .dark\\:bg-amber-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-blue-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-brand-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(117 81 255 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-cyan-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(33 212 253 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-gray-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(160 174 192 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-gray-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(37 47 64 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-green-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-indigo-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-indigo-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-lime-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(152 236 45 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-navy-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(54 82 186 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-navy-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(27 37 75 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-navy-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(11 20 55 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-orange-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-pink-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-purple-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-red-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-teal-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:bg-white\\/10:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}
  
  .dark\\:bg-white\\/20:is(.dark *){
  background-color: rgb(255 255 255 / 0.2);
}
  
  .dark\\:bg-white\\/30:is(.dark *){
  background-color: rgb(255 255 255 / 0.3);
}
  
  .dark\\:bg-white\\/5:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}
  
  .dark\\:bg-yellow-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 207 51 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:\\!text-gray-400:is(.dark *){
  --tw-text-opacity: 1 !important;
  color: rgb(160 174 192 / var(--tw-text-opacity, 1)) !important;
}
  
  .dark\\:\\!text-green-400:is(.dark *){
  --tw-text-opacity: 1 !important;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1)) !important;
}
  
  .dark\\:\\!text-navy-900:is(.dark *){
  --tw-text-opacity: 1 !important;
  color: rgb(11 20 55 / var(--tw-text-opacity, 1)) !important;
}
  
  .dark\\:\\!text-red-400:is(.dark *){
  --tw-text-opacity: 1 !important;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1)) !important;
}
  
  .dark\\:text-amber-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
  
  .dark\\:text-gray-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(163 174 208 / var(--tw-text-opacity, 1));
}
  
  .dark\\:text-green-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}
  
  .dark\\:text-navy-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(11 20 55 / var(--tw-text-opacity, 1));
}
  
  .dark\\:text-red-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
  
  .dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
  
  .dark\\:shadow-none:is(.dark *){
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  
  .dark\\:placeholder\\:\\!text-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.15\\)\\]:is(.dark *)::placeholder{
  color: rgba(255,255,255,0.15) !important;
}
  
  .dark\\:placeholder\\:\\!text-green-400:is(.dark *)::placeholder{
  --tw-text-opacity: 1 !important;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1)) !important;
}
  
  .dark\\:placeholder\\:\\!text-red-400:is(.dark *)::placeholder{
  --tw-text-opacity: 1 !important;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1)) !important;
}
  
  .dark\\:placeholder\\:\\!text-white:is(.dark *)::placeholder{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-amber-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-blue-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-brand-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(117 81 255 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-cyan-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 212 253 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-gray-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(160 174 192 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-green-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-indigo-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-lime-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(152 236 45 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-navy-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(54 82 186 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-orange-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-pink-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 114 182 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-purple-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(192 132 252 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-red-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-teal-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(45 212 191 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:\\!border-yellow-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(251 207 51 / var(--tw-border-opacity, 1)) !important;
}
  
  .dark\\:checked\\:bg-amber-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-blue-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-brand-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(117 81 255 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-cyan-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(33 212 253 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-gray-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(160 174 192 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-green-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-indigo-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-lime-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(152 236 45 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-navy-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(54 82 186 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-orange-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-pink-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-purple-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-red-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-teal-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:bg-yellow-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 207 51 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:checked\\:before\\:\\!bg-amber-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-blue-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-brand-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(117 81 255 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-cyan-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(33 212 253 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-gray-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(160 174 192 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-green-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-indigo-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-lime-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(152 236 45 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-navy-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(54 82 186 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-orange-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-pink-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-purple-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-red-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-teal-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:checked\\:before\\:\\!bg-yellow-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(251 207 51 / var(--tw-bg-opacity, 1)) !important;
}
  
  .dark\\:hover\\:bg-brand-300:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(129 113 252 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:hover\\:bg-white\\/20:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.2);
}
  
  .dark\\:hover\\:text-white:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
  
  .hover\\:dark\\:text-white:is(.dark *):hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
  
  .dark\\:hover\\:opacity-90:hover:is(.dark *){
  opacity: 0.9;
}
  
  .dark\\:active\\:bg-brand-200:active:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(161 149 253 / var(--tw-bg-opacity, 1));
}
  
  .dark\\:active\\:bg-white\\/10:active:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}
  
  .dark\\:active\\:opacity-80:active:is(.dark *){
  opacity: 0.8;
}
  
  .dark\\:active\\:opacity-90:active:is(.dark *){
  opacity: 0.9;
}
  
  @media (min-width: 576px){
  .sm\\:\\!mb-0{
    margin-bottom: 0px !important;
  }
  .sm\\:w-\\[460px\\]{
    width: 460px;
  }
  .sm\\:w-fit{
    width: fit-content;
  }
  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }
  .sm\\:flex-nowrap{
    flex-wrap: nowrap;
  }
  .sm\\:overflow-auto{
    overflow: auto;
  }
  .sm\\:overflow-x-auto{
    overflow-x: auto;
  }
}
  
  @media (min-width: 768px){
  .md\\:-left-\\[440px\\]{
    left: -440px;
  }
  .md\\:-start-\\[330px\\]{
    inset-inline-start: -330px;
  }
  .md\\:-start-\\[440px\\]{
    inset-inline-start: -440px;
  }
  .md\\:\\!z-50{
    z-index: 50 !important;
  }
  .md\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }
  .md\\:mr-5{
    margin-right: 1.25rem;
  }
  .md\\:mt-0{
    margin-top: 0px;
  }
  .md\\:mt-16{
    margin-top: 4rem;
  }
  .md\\:mt-2{
    margin-top: 0.5rem;
  }
  .md\\:block{
    display: block;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:w-1\\/2{
    width: 50%;
  }
  .md\\:w-\\[300px\\]{
    width: 300px;
  }
  .md\\:w-\\[365px\\]{
    width: 365px;
  }
  .md\\:w-\\[60\\%\\]{
    width: 60%;
  }
  .md\\:w-\\[85\\%\\]{
    width: 85%;
  }
  .md\\:max-w-\\[75\\%\\]{
    max-width: 75%;
  }
  .md\\:flex-grow-0{
    flex-grow: 0;
  }
  .md\\:origin-top-right{
    transform-origin: top right;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:flex-col{
    flex-direction: column;
  }
  .md\\:items-start{
    align-items: flex-start;
  }
  .md\\:justify-center{
    justify-content: center;
  }
  .md\\:\\!gap-14{
    gap: 3.5rem !important;
  }
  .md\\:gap-1{
    gap: 0.25rem;
  }
  .md\\:gap-10{
    gap: 2.5rem;
  }
  .md\\:border-0{
    border-width: 0px;
  }
  .md\\:\\!px-0{
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .md\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .md\\:px-\\[32px\\]{
    padding-left: 32px;
    padding-right: 32px;
  }
  .md\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .md\\:pe-2{
    padding-inline-end: 0.5rem;
  }
  .md\\:pl-12{
    padding-left: 3rem;
  }
  .md\\:pl-4{
    padding-left: 1rem;
  }
  .md\\:pr-0{
    padding-right: 0px;
  }
  .md\\:pr-2{
    padding-right: 0.5rem;
  }
  .md\\:text-center{
    text-align: center;
  }
  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:pe-2{
    padding-inline-end: 0.5rem;
  }
  [dir="ltr"] .md\\:origin-top-end{
    transform-origin: top right;
  }
  [dir="rtl"] .md\\:origin-top-end{
    transform-origin: top left;
  }
}
  
  @media (min-width: 992px){
  .lg\\:\\!z-50{
    z-index: 50 !important;
  }
  .lg\\:order-1{
    order: 1;
  }
  .lg\\:order-2{
    order: 2;
  }
  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .lg\\:\\!mb-0{
    margin-bottom: 0px !important;
  }
  .lg\\:mb-0{
    margin-bottom: 0px;
  }
  .lg\\:mb-10{
    margin-bottom: 2.5rem;
  }
  .lg\\:mb-6{
    margin-bottom: 1.5rem;
  }
  .lg\\:mt-0{
    margin-top: 0px;
  }
  .lg\\:block{
    display: block;
  }
  .lg\\:grid{
    display: grid;
  }
  .lg\\:w-\\[49vw\\]{
    width: 49vw;
  }
  .lg\\:max-w-\\[100\\%\\]{
    max-width: 100%;
  }
  .lg\\:max-w-\\[1013px\\]{
    max-width: 1013px;
  }
  .lg\\:max-w-\\[48\\%\\]{
    max-width: 48%;
  }
  .lg\\:max-w-\\[65\\%\\]{
    max-width: 65%;
  }
  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:flex-nowrap{
    flex-wrap: nowrap;
  }
  .lg\\:items-center{
    align-items: center;
  }
  .lg\\:justify-end{
    justify-content: flex-end;
  }
  .lg\\:justify-between{
    justify-content: space-between;
  }
  .lg\\:rounded-br-\\[120px\\]{
    border-bottom-right-radius: 120px;
  }
  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .lg\\:pb-0{
    padding-bottom: 0px;
  }
  .lg\\:pl-0{
    padding-left: 0px;
  }
  .lg\\:pt-0{
    padding-top: 0px;
  }
  .lg\\:pt-10{
    padding-top: 2.5rem;
  }
  .lg\\:text-white{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
  .lg\\:hover\\:text-white:hover{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
}
  
  @media (min-width: 1200px){
  .xl\\:\\!z-0{
    z-index: 0 !important;
  }
  .xl\\:mb-2{
    margin-bottom: 0.5rem;
  }
  .xl\\:ml-\\[313px\\]{
    margin-left: 313px;
  }
  .xl\\:mr-\\[313px\\]{
    margin-right: 313px;
  }
  .xl\\:hidden{
    display: none;
  }
  .xl\\:h-\\[350px\\]{
    height: 350px;
  }
  .xl\\:min-h-\\[100vh\\]{
    min-height: 100vh;
  }
  .xl\\:w-\\[1310px\\]{
    width: 1310px;
  }
  .xl\\:w-\\[225px\\]{
    width: 225px;
  }
  .xl\\:w-\\[300px\\]{
    width: 300px;
  }
  .xl\\:w-\\[365px\\]{
    width: 365px;
  }
  .xl\\:max-w-\\[1383px\\]{
    max-width: 1383px;
  }
  .xl\\:max-w-\\[420px\\]{
    max-width: 420px;
  }
  .xl\\:max-w-full{
    max-width: 100%;
  }
  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .xl\\:flex-row{
    flex-direction: row;
  }
  .xl\\:flex-col{
    flex-direction: column;
  }
  .xl\\:items-start{
    align-items: flex-start;
  }
  .xl\\:gap-2{
    gap: 0.5rem;
  }
  .xl\\:overflow-x-hidden{
    overflow-x: hidden;
  }
  .xl\\:rounded-br-\\[200px\\]{
    border-bottom-right-radius: 200px;
  }
  .xl\\:\\!px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
  .xl\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .xl\\:pb-6{
    padding-bottom: 1.5rem;
  }
  .xl\\:pl-\\[70px\\]{
    padding-left: 70px;
  }
}
  
  @media (min-width: 1320px){
  .\\32xl\\:col-span-6{
    grid-column: span 6 / span 6;
  }
  .\\32xl\\:w-\\[44vw\\]{
    width: 44vw;
  }
  .\\32xl\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  .\\32xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .\\32xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .\\32xl\\:items-start{
    align-items: flex-start;
  }
  .\\32xl\\:overflow-hidden{
    overflow: hidden;
  }
}
  
  @media (min-width: 1600px){
  .\\33xl\\:mr-5{
    margin-right: 1.25rem;
  }
  .\\33xl\\:mt-0{
    margin-top: 0px;
  }
  .\\33xl\\:h-full{
    height: 100%;
  }
  .\\33xl\\:w-\\[25\\%\\]{
    width: 25%;
  }
  .\\33xl\\:w-\\[33\\%\\]{
    width: 33%;
  }
  .\\33xl\\:w-\\[35\\%\\]{
    width: 35%;
  }
  .\\33xl\\:w-\\[45\\%\\]{
    width: 45%;
  }
  .\\33xl\\:w-\\[55\\%\\]{
    width: 55%;
  }
  .\\33xl\\:w-\\[65\\%\\]{
    width: 65%;
  }
  .\\33xl\\:w-\\[67\\%\\]{
    width: 67%;
  }
  .\\33xl\\:w-\\[75\\%\\]{
    width: 75%;
  }
  .\\33xl\\:w-full{
    width: 100%;
  }
  .\\33xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .\\33xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .\\33xl\\:flex-row{
    flex-direction: row;
  }
  .\\33xl\\:flex-col{
    flex-direction: column;
  }
  .\\33xl\\:items-center{
    align-items: center;
  }
  .\\33xl\\:justify-between{
    justify-content: space-between;
  }
  .\\33xl\\:border-r{
    border-right-width: 1px;
  }
  .\\33xl\\:border-\\[\\#EBEBEB\\]{
    --tw-border-opacity: 1;
    border-color: rgb(235 235 235 / var(--tw-border-opacity, 1));
  }
  .\\33xl\\:pl-5{
    padding-left: 1.25rem;
  }
  .\\33xl\\:pl-\\[10px\\]{
    padding-left: 10px;
  }
  .\\33xl\\:pr-\\[10px\\]{
    padding-right: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;;CAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;;CAAc;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAAd;EAAA,6CAAc;EAAd,wCAAc;EAAd,mCAAc;EAAd,sBAAc;CAAA;AACd;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,gFAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mKAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAWnB;CACC,gDAA2C;CAC3C,YAAY;CACZ,UAAU;CACV,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,+BAA+B;AAChC;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,qBAAqB;CACrB,qBAAqB;CACrB,kBAAkB;CAClB,wBAAwB;CACxB,+BAA+B;CAC/B,wBAAwB;CACxB,+BAA+B;CAC/B,+BAA+B;AAChC;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,iCAAiC;CACjC,aAAa;CACb,8BAA8B;CAC9B,4CAA4C;AAC7C;;AAEA;CACC;EACC,+CAA+C;CAChD;AACD;;AAEA;CACC;EACC,+CAA+C;CAChD;AACD;;AAEA;CACC,YAAY;CACZ,2BAA2B;CAC3B,kCAAkC;AACnC;;AAEA;CACC;EACC,8BAA8B;EAC9B,qCAAqC;CACtC;AACD;;AAEA;CACC;EACC,8BAA8B;EAC9B,qCAAqC;CACtC;AACD;;AAEA;CACC;EACC,8BAA8B;EAC9B,qCAAqC;CACtC;AACD;;AAEA;CACC,4DAA4D;CAC5D,2BAA2B;CAC3B,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,2BAA2B;CAC3B,yBAAiB;SAAjB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,+BAA+B;CAC/B,8BAA8B;CAC9B,iBAAiB;CACjB,WAAW;CACX,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,WAAW;CACX,mBAAmB;CACnB,8BAA8B;CAC9B,oCAAoC;AACrC;;AAEA;CACC,2EAA2E;CAE3E,gBAAgB;CAChB,6BAA6B;CAC7B,0BAA0B;CAC1B,oBAAoB;CACpB,qBAAqB;CACrB,eAAe;CACf,SAAS;CACT,UAAU;CACV,SAAS;CACT,4DAA4D;CAC5D,aAAa;CACb,cAAc;CACd,kBAAkB;CAClB,uBAAuB;CACvB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,8CAA8C;AAC/C;;AAEA;CACC,2EAA2E;CAE3E,gBAAgB;CAChB,6BAA6B;CAC7B,0BAA0B;CAC1B,oBAAoB;CACpB,qBAAqB;CACrB,eAAe;CACf,SAAS;CACT,UAAU;CACV,SAAS;CACT,aAAa;CACb,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,4DAA4D;CAC5D,aAAa;CACb,cAAc;CACd,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,+CAA+C;AAChD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;CACC,WAAW;CACX,eAAe;EACd;;EAEA;;CAED,YAAY;EACX;;EAEA;CACD,iBAAiB;CACjB,oBAAoB;EACnB;;EAEA;CACD,2BAA2B;CAC3B,sBAAsB;CACtB,YAAY;CACZ,aAAa;EACZ;;EAEA;CACD,cAAc;CACd,WAAW;EACV;;EAEA;;CAED,yBAAyB;EACxB;;EAEA;CACD,8BAA8B;EAC7B;;EAEA,2BAA2B;EAC3B;CACD,yBAAyB;EACxB;EACA;CACD,kCAAkC;CAClC,4BAA4B;CAC5B,+BAA+B;EAC9B;;EAEA;CACD,sBAAsB;EACrB;EACA;CACD,wBAAwB;EACvB;EACA;CACD,eAAe;EACd;;EAEA;CACD,YAAY;EACX;;EAEA;;CAED,kBAAkB;EACjB;EACA;CACD,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,UAAU;EACT;;EAEA;CACD,uDAAuD;CACvD,qBAAqB;EACpB;;EA9RF;EAAA,+BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,sBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,qBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,sBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,wCA8RG;EA9RH,qDA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,wJA8RG;EA9RH,wDA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,wBA8RG;EA9RH,wDA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,gBA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,sBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iBA8RG;EA9RH,iBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,sBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,4DA8RG;EA9RH,qEA8RG;EA9RH;AA8RG;;EA9RH;EAAA,2EA8RG;EA9RH,qEA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,+BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,+EA8RG;EA9RH,mGA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,8BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,2GA8RG;EA9RH,yGA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,+BA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,qBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,gFA8RG;EA9RH,oGA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,+BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,+BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,+BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,+BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,sBA8RG;EA9RH,8BA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,+BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,+BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,+BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,iCA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,0BA8RG;EA9RH,6BA8RG;EA9RH;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA,oBA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA,kBA8RG;EA9RH;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;AA8RG;;EA9RH;EAAA;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;AAAA;;EA9RH;EAAA;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA,gBA8RG;IA9RH;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA,4BA8RG;IA9RH;EA8RG;EA9RH;IAAA,kBA8RG;IA9RH;EA8RG;EA9RH;IAAA,kBA8RG;IA9RH;EA8RG;EA9RH;IAAA,mBA8RG;IA9RH;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA,mBA8RG;IA9RH;EA8RG;EA9RH;IAAA,kBA8RG;IA9RH;EA8RG;EA9RH;IAAA,eA8RG;IA9RH;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;AAAA;;EA9RH;EAAA;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA,kBA8RG;IA9RH;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA,oBA8RG;IA9RH;EA8RG;EA9RH;IAAA,oBA8RG;IA9RH;EA8RG;AAAA;;EA9RH;EAAA;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA,6BA8RG;IA9RH;EA8RG;EA9RH;IAAA,iBA8RG;IA9RH;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;AAAA;;EA9RH;EAAA;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;AAAA;;EA9RH;EAAA;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA,sBA8RG;IA9RH;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;EA9RH;IAAA;EA8RG;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap');\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n\thtml {\n\t\tfont-family: 'DM Sans', sans-serif !important;\n\t\tfont-feature-settings: 'kern' !important;\n\t\t-webkit-font-smoothing: antialiased;\n\t\tletter-spacing: -0.5px;\n\t}\n}\n\ninput.defaultCheckbox::before {\n\tcontent: url(../src/assets/svg/checked.svg); \n\tcolor: white;\n\topacity: 0; \n\theight: 16px; \n\twidth: 16px;\n\tposition: absolute; \n\tleft: 50%;\n\ttransform: translate(-50%, 0px);\n} \n\ninput:checked.defaultCheckbox::before { \n\topacity: 1;\n}\n\na {\n\ttext-decoration: none !important;\n}\n\na:hover {\n\ttext-decoration: none !important;\n}\n\n.embla {\n\t/* max-width: 70rem; */\n\t/* margin: auto; */\n\t--slide-height: 150px;\n\t--slide-spacing: 0rem;\n\t--slide-size: 100%;\n\t--slide-spacing-sm: 0rem;\n\t--slide-size-sm: calc(100% / 2);;\n\t--slide-spacing-lg: 0rem;\n\t--slide-size-md: calc(100% / 3);\n\t--slide-size-lg: calc(100% / 5);\n}\n\n.embla__viewport {\n\toverflow-x: hidden;\n\toverflow-y: hidden;\n}\n\n.embla__container {\n\t/* backface-visibility: hidden; */\n\tdisplay: flex;\n\ttouch-action: pan-y pinch-zoom;\n\tmargin-left: calc(var(--slide-spacing) * -1);\n}\n\n@media (min-width: 750px) {\n\t.embla__container {\n\t\tmargin-left: calc(var(--slide-spacing-sm) * -1);\n\t}\n}\n\n@media (min-width: 1200px) {\n\t.embla__container {\n\t\tmargin-left: calc(var(--slide-spacing-md) * -1);\n\t}\n}\n\n.embla__slide {\n\tmin-width: 0;\n\tflex: 0 0 var(--slide-size);\n\tpadding-left: var(--slide-spacing);\n}\n\n@media (min-width: 750px) {\n\t.embla__slide {\n\t\tflex: 0 0 var(--slide-size-sm);\n\t\tpadding-left: var(--slide-spacing-sm);\n\t}\n}\n\n@media (min-width: 1200px) {\n\t.embla__slide {\n\t\tflex: 0 0 var(--slide-size-md);\n\t\tpadding-left: var(--slide-spacing-lg);\n\t}\n}\n\n@media (min-width: 1700px) {\n\t.embla__slide {\n\t\tflex: 0 0 var(--slide-size-lg);\n\t\tpadding-left: var(--slide-spacing-lg);\n\t}\n}\n\n.embla__slide__number {\n\tbox-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);\n\t/* border-radius: 1.8rem; */\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: var(--slide-height);\n\tuser-select: none;\n}\n\n.embla__controls {\n\tdisplay: flex;\n\tgrid-template-columns: auto 1fr;\n\tjustify-content: space-between;\n\t/* width: 100%; */\n\tgap: 1.2rem;\n\t/* margin-top: 1.8rem; */\n}\n\n.embla__buttons {\n\tdisplay: flex;\n\tgrid-template-columns: repeat(2, 1fr);\n\tgap: 0.7rem;\n\talign-items: center;\n\t/* width: calc(100% + 52px); */\n\t/* justify-content: space-between; */\n}\n\n.embla__button {\n\t-webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);\n\t-webkit-appearance: none;\n\tappearance: none;\n\tbackground-color: transparent;\n\ttouch-action: manipulation;\n\tdisplay: inline-flex;\n\ttext-decoration: none;\n\tcursor: pointer;\n\tborder: 0;\n\tpadding: 0;\n\tmargin: 0;\n\tbox-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);\n\twidth: 1.6rem;\n\theight: 1.6rem;\n\tborder-radius: 50%;\n\tcolor: var(--text-body);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.embla__button:disabled {\n\tcolor: var(--detail-high-contrast);\n}\n\n.embla__button__svg {\n\twidth: 35%;\n\theight: 35%;\n}\n\n.embla__dots {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: flex-end;\n\talign-items: center;\n\tmargin-right: calc((2.6rem - 1.4rem) / 2 * -1);\n}\n\n.embla__dot {\n\t-webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);\n\t-webkit-appearance: none;\n\tappearance: none;\n\tbackground-color: transparent;\n\ttouch-action: manipulation;\n\tdisplay: inline-flex;\n\ttext-decoration: none;\n\tcursor: pointer;\n\tborder: 0;\n\tpadding: 0;\n\tmargin: 0;\n\twidth: 2.6rem;\n\theight: 2.6rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n}\n\n.embla__dot:after {\n\tbox-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);\n\twidth: 1.4rem;\n\theight: 1.4rem;\n\tborder-radius: 50%;\n\tdisplay: flex;\n\talign-items: center;\n\tcontent: '';\n}\n\n.embla__dot--selected:after {\n\tbox-shadow: inset 0 0 0 0.2rem var(--text-body);\n}\n\n.rs-avatar {\n  width: 80px !important;\n  height: 80px !important;\n  border-radius: 50%;\n}\t\n.rs-avatar>.rs-avatar-image {\n  width: 80px !important;\n  height: auto !important;\n}\n.swiper {\n\twidth: 100%;\n\tpadding: 50px 0;\n  }\n  \n  .features-swiper .swiper-slide,\n  .testimonials-swiper .swiper-slide {\n\theight: auto;\n  }\n  \n  .showcase-swiper {\n\tpadding-top: 50px;\n\tpadding-bottom: 50px;\n  }\n  \n  .showcase-swiper .swiper-slide {\n\tbackground-position: center;\n\tbackground-size: cover;\n\twidth: 300px;\n\theight: 300px;\n  }\n  \n  .showcase-swiper .swiper-slide img {\n\tdisplay: block;\n\twidth: 100%;\n  }\n  \n  .swiper-button-next,\n  .swiper-button-prev {\n\tcolor: #7F03E2 !important;\n  }\n  \n  .swiper-pagination-bullet-active {\n\tbackground: #7F03E2 !important;\n  }\n  \n  /* Add smooth transitions */\n  .swiper-slide {\n\ttransition: all 0.3s ease;\n  }\n  .swiper-initialized .swiper-wrapper {\n\ttransition-timing-function: linear;\n\tpadding-top: 40px !important;\n\tpadding-bottom: 40px !important;\n  }\n  \n  .swiper-slide-active {\n\ttransform: scale(1.05);\n  }\n  .swiper-button-next, .swiper-button-prev {\n\tdisplay: none !important;\n  }\n  .features-swiper {\n\tpadding: 50px 0;\n  }\n  \n  .features-swiper .swiper-slide {\n\twidth: 400px;\n  }\n  \n  .features-swiper .swiper-slide-shadow-left,\n  .features-swiper .swiper-slide-shadow-right {\n\tborder-radius: 8px;\n  }\n  .features-swiper .swiper-pagination-bullet {\n\twidth: 10px;\n\theight: 10px;\n\tbackground: #e9d5ff;\n\topacity: 1;\n  }\n  \n  .features-swiper .swiper-pagination-bullet-active {\n\tbackground: linear-gradient(to right, #9333ea, #db2777);\n\ttransform: scale(1.2);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
